export const clientConfirmationResources = {
	es: {
		['review_client']: 'Revisa',
		['rez_number']: 'Número de Reservación',
        ['full_name']: 'Nombre Completo',
        ['email']: 'E-mail',
        ['phone']: 'Teléfono',
        ['address']: 'Dirección',
        ['id_card']: 'Identificación',
        ['license']: 'Licencia',
        ['preview']: 'Vista Previa',
        ['expires']: 'Expira',
        ['invoice_required']: 'Requiere factura',

        ['edit_email']: 'Edita tu correo electrónico',
        ['enter_email']: 'Ingresa tu email',

        ['enter_address']: 'Anota tu dirección',
        ['address_type']: 'Tipo de dirección',
        ['street_1']: 'Calle 1',
        ['enter_street_1']: 'Ingresa una calle',
        ['street_2']: 'Calle 2 (opcional)',
        ['enter_street_2']: 'Ingresa una segunda calle',
        ['zip_code']: 'CP',
        ['city']: 'Ciudad',
        ['enter_city']: 'Ingresa una ciudad',
        ['state']: 'Estado',
        ['enter_state']: 'Ingresa un estado',
        ['country']: 'País',

        ['enter_tax_details']: 'Escribe tus datos fiscales',
        ['rfc']: 'RFC',
        ['enter_rfc']: 'Ingresa tu RFC',
        ['tax_profile']: 'Perfil Fiscal',
        ['tax_regime']: 'Régimen Fiscal',
        ['legal_name']: 'Razón Social',
        ['enter_legal_name']: 'Ingresa tu razón social',
        ['postal_code']: 'Código Postal',

	},
	en: {
		['review_client']: 'Review',
		['rez_number']: 'Reservation Number',
        ['full_name']: 'Full Name',
        ['email']: 'E-mail',
        ['phone']: 'Phone',
        ['address']: 'Address',
        ['id_card']: 'Identification',
        ['license']: 'License',
        ['preview']: 'Preview',
        ['expires']: 'Expires',
        ['invoice_required']: 'Invoice required',

        ['edit_email']: 'Edit your email address',
        ['enter_email']: 'Enter your email',

        ['enter_address']: 'Enter your address',
        ['address_type']: 'Address type',
        ['street_1']: 'Street 1',
        ['enter_street_1']: 'Enter a street',
        ['street_2']: 'Street 2 (optional)',
        ['enter_street_2']: 'Enter a second street',
        ['zip_code']: 'Zip Code',
        ['city']: 'City',
        ['enter_city']: 'Enter a city',
        ['state']: 'State',
        ['enter_state']: 'Enter a state',
        ['country']: 'Country',

        ['enter_tax_details']: 'Enter your tax details',
        ['rfc']: 'RFC',
        ['enter_rfc']: 'Enter your RFC',
        ['tax_profile']: 'Tax Profile',
        ['tax_regime']: 'Tax Regime',
        ['legal_name']: 'Company Name',
        ['enter_legal_name']: 'Enter your legal name',
        ['postal_code']: 'Zip Code',
	}
}
